export const userRoutes = [
  {
    path: '/',
    load: () => new Promise((resolve, reject) => {
      resolve(
        require('./home'));
      reject(error);
    }),
  },
  {
    path: '/contact',
    load: () => new Promise((resolve, reject) => {
      resolve(
        require('./contact'));
      reject(error);
    }),
  },
  {
    path: '/about',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./about'));
      reject(error);
    }),
  },
  {
    path: '/privacy',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./privacy'));
      reject(error);
    }),
  },
  {
    path: '/login',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./login'));
      reject(error);
    }),
  },
  {
    path: '/support',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./static/support'));
      reject(error);
    }),
  },
  {
    path: '/partner/privacy-policy',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./static/partnerPrivacyPolicy'));
      reject(error);
    }),
  },

  {
    path: '/user',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./static/user'));
      reject(error);
    }),
  },
  {
    path: '/partner',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./static/partner'));
      reject(error);
    }),
  },
  {
    path: '/category',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./category'));
      reject(error);
    }),
  },
  {
    path: '/legal',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./static/legal'));
      reject(error);
    }),
  },
  {
    path: '/dashboard',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./dashboard'));
      reject(error);
    }),
  },
  {
    path: '/order/:id',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./booking'));
      reject(error);
    }),
  },
  {
    path: '/bookings/:type',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./bookings'));
      reject(error);
    }),
  },
  {
    path: '/payment-method',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./paymentMethod'));
      reject(error);
    }),
  },
  {
    path: '/profile',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./profile'));
      reject(error);
    }),
  },
  {
    path: '/tracking/:id',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./tracking'));
      reject(error);
    }),
  },
  {
    path: '/chat-message/:id',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./chatMessage'));
      reject(error);
    }),
  },
  {
    path: '/booking/:id',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./book'));
      reject(error);
    }),
  },
  {
    path: '/add-wallet',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./addWallet'));
      reject(error);
    }),
  },
  {
    path: '/add-card',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./addCard'));
      reject(error);
    }),
  },
  {
    path: '/terms-of-service',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./static/termsOfService'));
      reject(error);
    }),
  },
  {
    path: '/:pageUrl',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./page'));
      reject(error);
    }),
  },
];